import React from 'react';

function InputField({ id, label, icon: Icon, className = '', ...props }) {
  return (
    <div className={className}>
      <label htmlFor={id} className="mb-2 block text-sm font-medium text-slate-700">
        {label}
      </label>
      <div className="relative">
        {Icon && (
          <Icon
            aria-hidden="true"
            className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400"
          />
        )}
        <input
          id={id}
          className={[
            'focus-ring h-12 w-full rounded-xl border border-slate-200 bg-white px-4 text-sm text-slate-950 shadow-sm shadow-slate-900/5 transition placeholder:text-slate-400 hover:border-slate-300',
            Icon ? 'pl-10' : '',
          ].join(' ')}
          {...props}
        />
      </div>
    </div>
  );
}

export default InputField;
